import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { StatementService } from "app/statements/statement.service";
import { SnackbarConfig, SubscribingComponent } from "app/common";
import { getSelectsData, getUser, State } from "app/reducers";
import { Store } from "@ngrx/store";
import { WorkflowControllerService } from "app/core/workflow/workflow-controller/workflow-controller.service";
import { Statement, SelectsDataInterface } from "..";
import { ToolsBarButtonInterface } from "app/shared/components/tools-bar/tools-bar.component";
import { SHOW_SNACKBAR } from "app/reducers/actions/snackbar";
import { PaymentService } from "app/payment/payment.service";
import { DashboardPagePath } from "app/core/workflow/page-path/dashboard-page.path";
import { User } from "app/users";

//http://localhost:4200/new/statement/260/confirm-premium-price

@Component({
  selector: "app-confirm-new-premium-price",
  templateUrl: "./confirm-new-premium-price.component.html",
  styleUrls: ["../../common/confirm-tax-return/ctr-base.component.scss", "./confirm-new-premium-price.component.scss"],
  standalone: false
})
export class ConfirmNewPremiumPriceComponent extends SubscribingComponent implements OnInit {
  public statement: Statement;
  public dataSelects: SelectsDataInterface;
  private statementId: number;
  private _isInitialized = false;
  private loadingStatementData = true;
  private loadingSelectsData = true;
  public isLoading = true;
  public buttons: ToolsBarButtonInterface[] = [
    {
      type: "proceed",
      label: "COMMON.CONFIRM",
      action: this.proceed.bind(this)
    }
  ];

  constructor(
    private statementService: StatementService,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<State>,
    public workFlowController: WorkflowControllerService
  ) {
    super();
  }

  ngOnInit(): void {
    combineLatest([this.route.params, this.store.select(getSelectsData), this.store.select(getUser)])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([params, selectsData, user]) => {
        if (params && selectsData && user) {
          if (!this.isB2cUser(user)) {
            this.router.navigate([DashboardPagePath.fullUrl()]);
            return;
          }

          this.dataSelects = selectsData;
          this.loadingSelectsData = false;

          this.statementId = parseInt(params["statementId"], 10);
          this.getStatementData();
        }
      });
  }

  private getStatementData(): void {
    this.statementService
      .getStatement(this.statementId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (responseStatement) => {
          this.statement = responseStatement;
          this.workFlowController.init(this.statement);
          this.loadingStatementData = false;
          this._isInitialized = true;
          this.isLoading = false;
        },
        error: () => {
          this.store.dispatch({
            type: SHOW_SNACKBAR,
            payload: new SnackbarConfig("COMMON.GLOBAL_ERROR", "ERROR")
          });
        }
      });
  }

  public get isInitialized(): boolean {
    return !!this.statement && this._isInitialized;
  }

  public confirmNewPrice(): void {
    this.paymentService
      .acceptNewPaymentAmount(this.statement.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: () => {
          this.router.navigate([DashboardPagePath.path()]);
        },
        error: () => {
          this.store.dispatch({
            type: SHOW_SNACKBAR,
            payload: new SnackbarConfig("COMMON.GLOBAL_ERROR", "ERROR")
          });
        }
      });
  }

  private proceed(): void {
    this.confirmNewPrice();
  }

  private isB2cUser(user: User): boolean {
    return !user.isBusiness && !user.isTaxAdviser;
  }
}
